/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostTeamsIdInviteRegenerateMutationResponse,
  PostTeamsIdInviteRegeneratePathParams,
  PostTeamsIdInviteRegenerate401,
  PostTeamsIdInviteRegenerate403,
  PostTeamsIdInviteRegenerate404,
  PostTeamsIdInviteRegenerate500,
} from "../types/PostTeamsIdInviteRegenerate.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postTeamsIdInviteRegenerateMutationKey = () =>
  [{ url: "/teams/:id/invite/regenerate" }] as const;

export type PostTeamsIdInviteRegenerateMutationKey = ReturnType<
  typeof postTeamsIdInviteRegenerateMutationKey
>;

/**
 * {@link /teams/:id/invite/regenerate}
 */
export async function postTeamsIdInviteRegenerate(
  id: PostTeamsIdInviteRegeneratePathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostTeamsIdInviteRegenerateMutationResponse,
    ResponseErrorConfig<
      | PostTeamsIdInviteRegenerate401
      | PostTeamsIdInviteRegenerate403
      | PostTeamsIdInviteRegenerate404
      | PostTeamsIdInviteRegenerate500
    >,
    unknown
  >({
    method: "POST",
    url: `/teams/${id}/invite/regenerate`,
    ...requestConfig,
  });
  return res;
}

export function postTeamsIdInviteRegenerateMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = postTeamsIdInviteRegenerateMutationKey();
  return mutationOptions<
    ResponseConfig<PostTeamsIdInviteRegenerateMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsIdInviteRegenerate401
      | PostTeamsIdInviteRegenerate403
      | PostTeamsIdInviteRegenerate404
      | PostTeamsIdInviteRegenerate500
    >,
    { id: PostTeamsIdInviteRegeneratePathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return postTeamsIdInviteRegenerate(id, config);
    },
  });
}

/**
 * {@link /teams/:id/invite/regenerate}
 */
export function usePostTeamsIdInviteRegenerate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostTeamsIdInviteRegenerateMutationResponse>,
      ResponseErrorConfig<
        | PostTeamsIdInviteRegenerate401
        | PostTeamsIdInviteRegenerate403
        | PostTeamsIdInviteRegenerate404
        | PostTeamsIdInviteRegenerate500
      >,
      { id: PostTeamsIdInviteRegeneratePathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postTeamsIdInviteRegenerateMutationKey();

  const baseOptions = postTeamsIdInviteRegenerateMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostTeamsIdInviteRegenerateMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsIdInviteRegenerate401
      | PostTeamsIdInviteRegenerate403
      | PostTeamsIdInviteRegenerate404
      | PostTeamsIdInviteRegenerate500
    >,
    { id: PostTeamsIdInviteRegeneratePathParams["id"] },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostTeamsIdInviteRegenerateMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsIdInviteRegenerate401
      | PostTeamsIdInviteRegenerate403
      | PostTeamsIdInviteRegenerate404
      | PostTeamsIdInviteRegenerate500
    >,
    { id: PostTeamsIdInviteRegeneratePathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostTeamsIdInviteRegenerateMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsIdInviteRegenerate401
      | PostTeamsIdInviteRegenerate403
      | PostTeamsIdInviteRegenerate404
      | PostTeamsIdInviteRegenerate500
    >,
    { id: PostTeamsIdInviteRegeneratePathParams["id"] },
    TContext
  >;
}
